module.exports = __webpack_public_path__ + "img/rule.4f6b3c1d.png";